import { Volume2, VolumeX } from "lucide-react";
import { useAmbience } from "../hooks/useAmbience";

export default function SoundToggle() {
  const { playing, toggle } = useAmbience();
  return (
    <button
      data-testid="sound-toggle-button"
      onClick={toggle}
      title={playing ? "Mute the ocean" : "Play the ocean"}
      aria-label={playing ? "Mute ocean sounds" : "Play ocean sounds"}
      className={`btn-push sticker-sm flex items-center gap-1.5 rounded-full px-3 py-2 ${
        playing ? "bg-ocean-sky text-white" : "bg-ocean-bg2"
      }`}
    >
      {playing ? (
        <Volume2 className="h-4 w-4" />
      ) : (
        <VolumeX className="h-4 w-4" />
      )}
      <span className="hidden font-display text-xs font-semibold xl:inline">
        {playing ? "WAVES ON" : "WAVES OFF"}
      </span>
    </button>
  );
}
